// Silent, looping, responsive hero video. Playback controls are intentionally omitted.
class TrekcampHeroVideo extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.mobile = matchMedia('(max-width: 749px)');

    this.video.addEventListener('playing', () => this.setAttribute('data-ready', ''), options);
    this.video.addEventListener('error', () => this.removeAttribute('data-ready'), options);
    this.mobile.addEventListener('change', () => { this.loadSource(); this.resume(); }, options);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.video.pause(); else this.resume();
    }, options);

    this.loadSource();
    this.resume();
  }

  loadSource() {
    const source = this.mobile.matches ? this.video.dataset.mobile : this.video.dataset.desktop;
    if (source && this.video.getAttribute('src') !== source) {
      this.removeAttribute('data-ready');
      this.video.src = source;
      this.video.muted = true;
      this.video.load();
    }
  }

  resume() {
    if (!document.hidden) this.video.play().catch(() => {});
  }

  disconnectedCallback() { this.abort?.abort(); this.video?.pause(); }
}

if (!customElements.get('trekcamp-hero-video')) customElements.define('trekcamp-hero-video', TrekcampHeroVideo);
